module.exports = __webpack_public_path__ + "static/img/apple-store.a198f4a6.png";